/*
 * Copyright (c) 2021.  Blacksheepz media B.V.
 * https://www.blacksheepz-media.com
 * Ramon van Ophuizen
 */

import React, { useState, useEffect, useRef } from "react";
import { withTranslation } from "react-i18next";
import { useForm } from "react-hook-form";
import moment from "moment-timezone";
import { Grid, TextField,  FormControlLabel, Checkbox } from "@material-ui/core";
import { NavLink } from "react-router-dom";
import CreditCardIcon from "@material-ui/icons/CreditCard";
import LinearProgress from "@material-ui/core/LinearProgress";
import Alert from "@material-ui/lab/Alert";


import CartComponent from "../Product/CartComponent";

import { useQuery, useMutation } from "@apollo/client";
import {
  CLASSES_OF_SCHOOL,
  CREATE_ORDERS,
  SHIPPING_METHODS,
  GET_ADDRESS,
} from "../../queries";
import { useThemeData } from "../../context/ThemeDataContext";
import { usePhotoBaseData } from "../../context/PhotoBasicDataContext";
import { useCartData } from "../../context/CartProvider";

import { yupResolver } from "@hookform/resolvers/yup";
import { AddressSchema } from "../../validations/AddressValidation";
import { formContent } from "../../statics/AddressFormData";
import { useCallback } from "react";
import GeneralButton from "../Buttons";

function OrderFormComponent(props) {
  const { oudste_kind_klas, shippingcost_free_period, newsletter  } = useThemeData().modules;
  const { site_id, siteoptions } = useThemeData().themeData.site;
  const { primary_color_2 } = useThemeData().themeData.site.theme;
  const { photographerType } = useThemeData();
  const { shippingcost_type, type } = useCartData().cart.cartData.shoppingcart;
  const equestrianPS =
      photographerType === "equestrianphotoservice"
          ? "equestrianphotoservice"
          : undefined;

  const oudste_kind_k = equestrianPS ? false : oudste_kind_klas;
  const shippingcost_free = equestrianPS ? true : shippingcost_free_period;

  const { schoolInfo } = usePhotoBaseData();
  const { default_photo_id } = usePhotoBaseData().photoDefaultSettings;
  const [session_id] = useState(localStorage.getItem("session_id"));
  const [CustomerData, setCustomerData] = useState({
    klant_straat: undefined,
    klant_huisnummer: "",
    klant_postcode: "",
    klant_plaats: undefined,
    klant_houseAddition: undefined,
    klant_oudste_kind: "",
    klant_oudste_kind_klas: "",
  });
  const [foreignOption, setforeignOption] = useState(false);
  const [schooldata, setSchoolData] = useState({
    id: "",
    folder_name: "",
    administratiekosten: "",
  });
  const [foreign, setForeign] = useState(false);
  const [newsLetter, setNewsLetter] = useState(true);
  const [socialMedia, setSocialMedia] = useState(false);
  const [validation, setValidation] = useState({
    validatingZipcode: false,
    validatingHouseNumber: null,
    klant_email: null,
    klant_straat: null,
    klant_plaats: null,
    klant_oudste_kind: null,
    klant_oudste_kind_klas: null,
    shipping_urgent: null,
    acceptTerms: null,
  });

  const prevShippingMethodRef = useRef();

  const login = localStorage.hasOwnProperty("login_name")
      ? localStorage.getItem("login_name")
      : undefined;

  const [error, setError] = useState(undefined);
  const [urgent, setUrgent] = useState(0);

  const [shippingByHandMethod, setShippingByHandMethod] = useState(undefined);
  const [shippingMethod, setShippingMethod] = useState(undefined);

  const {
    register,
    setValue,
    handleSubmit,
    trigger,
    formState: { errors },
  } = useForm({
    resolver: yupResolver(AddressSchema),
    mode: "all",
    reValidateMode: "onSubmit",
  });

  let express_delivery = siteoptions.filter(
      (site) => site.option_name === "express_delivery"
  );

  let comments = siteoptions.filter(
      (site) => site.option_name === "comments"
  );


  if(comments.length === 0){
    comments = true;
  }

  const [
    createOrder,
    { loading: loadingCreateOrder, error: errorCreateOrder },
  ] = useMutation(CREATE_ORDERS, {
    onCompleted: (event) => {
      localStorage.setItem("order_id", event.createOrder.bestelling_id);
      props.history.push("/checkout");
    },
  });

  const [
    getAddressByZipcode,
    { loading: loadingAddressByZipcode, error: errorAddressByZipcode },
  ] = useMutation(GET_ADDRESS, {
    onCompleted: (event) => {
      if (
          event.getAddressByZipcode.city !== null &&
          event.getAddressByZipcode.street !== null
      ) {
        setValidation((prevState) => ({
          ...prevState,
          validatingZipcode: false,
          validatingHouseNumber: false,
        }));
        setCustomerData((prevState) => ({
          ...prevState,
          klant_plaats: event.getAddressByZipcode.city,
          klant_straat: event.getAddressByZipcode.street,
          klant_houseAddition: event.getAddressByZipcode.houseAddition,
        }));


      } else {
        setValidation((prevState) => ({
          ...prevState,
          validatingZipcode: false,
          validatingHouseNumber: false,
        }));
        setCustomerData((prevState) => ({
          ...prevState,
          klant_plaats: "",
          klant_straat: "",
        }));
      }

      // Set the values to the react-hook-form and trigger validation
      setValue("klant_straat", event.getAddressByZipcode.city);
      setValue("klant_plaats", event.getAddressByZipcode.street);
      trigger(["klant_straat", "klant_plaats"]);
    },
    onError: (error) => {
      setForeign(true);
      setCustomerData((prevState) => ({
        ...prevState,
        klant_plaats: "",
        klant_straat: "",
      }));
      setError(error.message);
    },
  });

  const {
    loading: loadingClassSchool,
    error: errorClassSchool,
    data: dataClassSchool,
  } = useQuery(CLASSES_OF_SCHOOL, {
    variables: {
      login_name: login,
      id: default_photo_id,
    },
    skip: oudste_kind_k !== "true" || !default_photo_id || !login,
  });

  useEffect(() => {
    if (!loadingClassSchool && !errorClassSchool) {
      if (dataClassSchool) {
        if (CustomerData.klant_oudste_kind_klas === "") {
          if (dataClassSchool.classesofschool.length >= 0) {
            setCustomerData((prevState) => ({
              ...prevState,
              klant_oudste_kind_klas:
              dataClassSchool.classesofschool[0].folder_name,
            }));
          }
        }
      }
    }
  }, [
    dataClassSchool,
    loadingClassSchool,
    errorClassSchool,
    CustomerData.klant_oudste_kind_klas,
  ]);

  const {
    loading: loadingShippingMethod,
    error: errorShippingMethod,
    data: dataShippingMethod,
  } = useQuery(SHIPPING_METHODS, {
    variables: {
      site_id: site_id,
      shippingcost_type: shippingcost_type,
    },
    fetchPolicy: "network-only",
    skip: shippingcost_type === undefined || site_id === "",
  });

  useEffect(() => {
    if (schoolInfo.default_school_id !== undefined) {

      if(shippingcost_type==='download'){
        setSchoolData({
          id: schoolInfo.default_school_id,
          administratiekosten: 0,
          folder_name: schoolInfo.folder_name,
        });
      }else{
        setSchoolData({
          id: schoolInfo.default_school_id,
          administratiekosten: schoolInfo.administratiekosten,
          folder_name: schoolInfo.folder_name,
        });
      }


      setforeignOption(schoolInfo.foreign);
    }
  }, [schoolInfo, shippingcost_type]);

  useEffect(() => {
    let klant_postcode_clean = CustomerData.klant_postcode.replace(/\s/g, "");

    if (klant_postcode_clean || CustomerData.klant_huisnummer) {
      let timeout;
      if (timeout) clearTimeout(timeout);
      timeout = setTimeout(() => {
        if (
            klant_postcode_clean !== "" &&
            CustomerData.klant_huisnummer !== ""
        ) {
          const postcode = klant_postcode_clean.length;
          const huisnummer = CustomerData.klant_huisnummer.length;
          if (postcode >= 4 && huisnummer >= 1) {
            if (
                !errors["klant_postcode"] &&
                !errors["klant_huisnummer"] &&
                foreign === false
            ) {
              setValidation((prevState) => ({
                ...prevState,
                validatingZipcode: true,
                validatingHouseNumber: true,
              }));
            } else {
              setValidation((prevState) => ({
                ...prevState,
                validatingZipcode: false,
                validatingHouseNumber: false,
              }));
            }
          } else {
            setValidation((prevState) => ({
              ...prevState,
              validatingZipcode: false,
              validatingHouseNumber: false,
            }));
          }
        } else {
          setValidation((prevState) => ({
            ...prevState,
            validatingZipcode: false,
            validatingHouseNumber: false,
          }));
        }
      }, 100);
    }
  }, [
    CustomerData.klant_postcode,
    CustomerData.klant_huisnummer,
    foreign,
    errors,
  ]);

  const setAddressAndValidation = useCallback(() => {
    let klant_postcode_clean = CustomerData.klant_postcode.replace(/\s/g, "");

    getAddressByZipcode({
      variables: {
        housenumber: CustomerData.klant_huisnummer,
        zipcode: klant_postcode_clean
      },
    });
    setValidation((prevState) => ({
      ...prevState,
      validatingZipcode: false,
      validatingHouseNumber: false,
      klant_straat: true,
      klant_plaats: true,
    }));
  }, [
    CustomerData.klant_huisnummer,
    CustomerData.klant_postcode,
    getAddressByZipcode,
  ]);

  useEffect(() => {
    if (
        validation.validatingZipcode === true &&
        validation.validatingHouseNumber === true
    ) {
      setAddressAndValidation();
    }
  }, [
    validation.validatingZipcode,
    validation.validatingHouseNumber,
    setAddressAndValidation,
  ]);

  const  handleNewsletter = (e) => {
    setNewsLetter(e.target.checked);
  }

  const  handleSocialMedia = (e) => {
    setSocialMedia(e.target.checked);
  }

  const handleAcceptTerms = (e) => {
    const { checked } = e.target;
    console.log("Checkbox checked state:", checked); // Debug log
    setValidation(prevState => ({
      ...prevState,
      acceptTerms: checked
    }));
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setCustomerData((prevState) => ({
      ...prevState,
      [name]: value,
    }));
    if (
        name === "klant_straat" ||
        name === "klant_plaats" ||
        "klant_oudste_kind"
    ) {
      if (value !== "") {
        setValidation((prevState) => ({
          ...prevState,
          [name]: true,
        }));
      } else {
        setValidation((prevState) => ({
          ...prevState,
          [name]: false,
        }));
      }
    }
  };

  useEffect(() => {
    if (
        CustomerData.klant_oudste_kind_klas === "select" ||
        CustomerData.klant_oudste_kind_klas === null
    ) {
      setValidation((prevState) => ({
        ...prevState,
        klant_oudste_kind_klas: false,
      }));
    } else {
      setValidation((prevState) => ({
        ...prevState,
        klant_oudste_kind_klas: true,
      }));
    }
  }, [CustomerData.klant_oudste_kind_klas]);

  let current_time = new Date();
  const verzendkostenvrij_korting_datum = moment(
      moment(schoolInfo.verzendkostenvrij_korting_datum).format(
          "YYYY-MM-DD"
      )
  ).isSameOrAfter(moment(current_time).format("YYYY-MM-DD"));

  useEffect(() => {
      if ((urgent === "select" || urgent === null || urgent === '0' || urgent === 0) && verzendkostenvrij_korting_datum === true) {

        setValidation((prevState) => ({
          ...prevState,
          // shipping_urgent: false,
        }));
        setShippingMethod('via school');

        localStorage.setItem("shippingMethod", 'vrij');

      } else {
        setValidation((prevState) => ({
          ...prevState,
          // shipping_urgent: true,
        }));


        setShippingMethod('laag');

        localStorage.setItem("shippingMethod", 'laag');
      }

    if (prevShippingMethodRef.current !== shippingByHandMethod && (urgent===0 || (urgent==='1' && verzendkostenvrij_korting_datum === true))) {
      setShippingMethod(shippingByHandMethod); // replace newShippingMethod with your new value
      localStorage.setItem("shippingMethod", shippingByHandMethod);
    }

  }, [urgent,shippingByHandMethod, setShippingMethod,shippingMethod, verzendkostenvrij_korting_datum, shippingcost_type]);


  useEffect(() => {
    if (shippingMethod === "select" || shippingMethod === null) {
      setValidation((prevState) => ({
        ...prevState,
        shipping_method: false,
      }));

    } else {
      setValidation((prevState) => ({
        ...prevState,
        shipping_method: true,
      }));
    }
  }, [shippingMethod]);

  console.log(CustomerData.klant_huisnummer);

  const onSubmit = (e) => {
    let klant_oudste_kind_klas = e.klant_oudste_kind_klas;
    const klant_oudste_kind = e.klant_oudste_kind ? e.klant_oudste_kind : "";
    const opmerking = e.opmerking ? e.opmerking : "";
    const shipping_method = shippingMethod;

    const housenumberInput = CustomerData.klant_huisnummer; // Example: "8 bus1"

// Regular expression to capture the first group of digits and any subsequent non-digit characters as separate groups
    const regex = /^(\d+)\s*(.*)$/;

    let customer_house_number = null;
    let customer_house_number_suffix = null;

// Extract house number and suffix
    const match = housenumberInput.match(regex);
    if (match) {
      customer_house_number = match[1]; // The first group (digits)
      customer_house_number_suffix = match[2]; // The second group (non-digits, if any)
    } else {
      // Handle the case where no house number and suffix are found
      customer_house_number = housenumberInput; // Default to the original input
      customer_house_number_suffix = null; // No suffix
    }


    if (!klant_oudste_kind_klas) {
      klant_oudste_kind_klas = CustomerData.klant_oudste_kind_klas;
    }

    const userId = props.user_id || 220;
    const event_id = localStorage.getItem('event_id');
    const school_id = event_id && event_id.trim() !== '' ? event_id : schooldata.id;

    createOrder({
      variables: {
        user_id: userId,
        site_id: site_id,
        session_id: session_id,
        klant_naam: e.klant_voornaam,
        klant_voornaam: e.klant_voornaam,
        customer_preposition: e.customer_preposition,
        klant_achternaam: e.klant_achternaam,
        klant_straat: CustomerData.klant_straat,
        klant_huisnummer: customer_house_number,
        customer_house_number_suffix: customer_house_number_suffix,
        klant_postcode: CustomerData.klant_postcode,
        klant_plaats: CustomerData.klant_plaats,
        klant_land: "NL",
        klant_telnr: e.klant_telnr,
        klant_email: e.klant_email,
        klant_oudste_kind: klant_oudste_kind,
        klant_oudste_kind_klas: klant_oudste_kind_klas,
        newsletter:newsLetter,
        opmerking: opmerking,
        school_id: school_id,
        administratiekosten: schooldata.administratiekosten,
        shippingcost_type: shipping_method,
        school_naam: schooldata.folder_name,
        share_social_media: socialMedia,
        order_rules: {
          foto_id: 13,
          product_id: 13,
          site_id: site_id,
          product_naam: "test",
          product_formaat: "20x20",
          product_categorie: "Foto",
          oorspronkelijke_prijs_ps: "12",
          prijs_ps: "12",
          aantal: "12",
          effect: "12",
          totaalprijs: 10,
          foto_bestand: "12",
          opmerking: "testopmerking",
        },
      },
    });
  };

  if (CustomerData.klant_email === "" && validation.klant_email === null) {
    if (localStorage.hasOwnProperty("login_email")) {
      setCustomerData((prevState) => ({
        ...prevState,
        klant_email: localStorage.getItem("login_email"),
      }));
      setValidation((prevState) => ({ ...prevState, klant_email: true }));
    }
  }

  if (loadingClassSchool || loadingShippingMethod || loadingCreateOrder)
    return <p>{props.t("Loading...")}</p>;
  if (errorClassSchool || errorShippingMethod || errorCreateOrder)
    return <p>{props.t("Looks like we have a problem...")}</p>;

  /* spoed bestelling */
  let formRules  = formContent.inputs;
  if(express_delivery[0].option_value==='false'){
    formRules = formContent.inputs.filter((e) => e.name !== "shipping_urgent");
  }
  return (
    <form onSubmit={handleSubmit(onSubmit)} autocomplete="off">
      <Grid container direction="row" spacing={3}>
        <Grid item lg={6} md={6} sm={12} className="padding-around">
          <Grid container direction="row" spacing={1}>
            {formRules.map((input, key) => {


              const lg = key <= 2 ? 4 : 6;
              const download = type === "Only downloads";


              if(download){
                localStorage.setItem("shippingMethod", 'download');
              }


              const addressInputFields =
                  input.name === "klant_postcode" ||
                  input.name === "klant_huisnummer";
              const addressAutoFields =
                  input.name === "klant_straat" || input.name === "klant_plaats";
              const classesOfSchoolFields =
                  input.name === "klant_oudste_kind" ||
                  input.name === "klant_oudste_kind_klas";
              const shippingField = input.name === "shipping_method";
              const shippingUrgentField = input.name === "shipping_urgent";


              const shipping_method =
                  !download &&
                  ((shippingcost_type !== "vrij" &&
                          shippingcost_free !== "false") ||
                      urgent === "1") &&
                  dataShippingMethod.shippingmethods.length > 1;

              let shippingUrgentArray = ["Via school", "Op huisadres (met portokosten)"];

              // if (localStorage.hasOwnProperty("shippingMethod")) {
              //   shippingUrgentArray = [localStorage.getItem("shippingMethod"), "Via school", "Op huisadres (met portokosten)"];
              // }else{
              //   shippingUrgentArray = ["Via school", "Op huisadres (met portokosten)"];
              // }

              const valueInputAddressField =
                  addressInputFields === true && !download;

              const valueAutoAddressField =
                  addressAutoFields === true &&
                  (foreign ||
                      (!loadingAddressByZipcode &&
                          CustomerData.klant_straat !== undefined &&
                          CustomerData.klant_plaats !== undefined));

              //if klas_oudste_kind_keuze is true and classes found and shipping free period is within the date
              const valueClassesofSchoolField =
                  classesOfSchoolFields === true &&
                  oudste_kind_k !== "false" &&
                  (dataClassSchool ? dataClassSchool.classesofschool.length !== 0 : false) &&
                  verzendkostenvrij_korting_datum === true;


              // console.log(verzendkostenvrij_korting_datum);
              // console.log(valueClassesofSchoolField);

              const valueShippingUrgentField =
                  shippingUrgentField === true &&
                  !download &&
                  (
                      (verzendkostenvrij_korting_datum === true &&
                          shippingcost_free !== "false"));

              const valueShippingMethodField =
                  shippingField === true
                  &&
                  shipping_method === true
                  &&
                  (
                      (urgent === "1" && verzendkostenvrij_korting_datum === true) || (verzendkostenvrij_korting_datum === false)
                  );
                  // (
                  //     (urgent === "1" &&
                  //         verzendkostenvrij_korting_datum === true &&
                  //         shippingcost_free !== "false") ||
                  //     (urgent !== "1" &&
                  //         shippingcost_type !== "vrij")
                  // );

              // console.log(valueShippingMethodField);

              const display =
                  valueInputAddressField ||
                  valueAutoAddressField ||
                  valueClassesofSchoolField ||
                  valueShippingUrgentField ||
                  valueShippingMethodField;

              //addressfields: klant_straat, klant_postcode, klant_huisnummer, klant_plaats
              return addressInputFields === true || addressAutoFields === true ? (
                      <Grid
                          item
                          key={key}
                          lg={lg}
                          md={12}
                          sm={12}
                          xs={12}
                          className={`mb-2`}
                          style={{
                            display: `${
                                addressAutoFields === true || addressInputFields === true
                                    ? display
                                        ? "unset"
                                        : "none"
                                    : "unset"
                            }`,
                          }}
                      >
                        <TextField
                            required={JSON.parse(`${
                                download
                                ? false
                                : true
                            }`)}
                            {...register(input.name, { shouldUnregister: true })}
                            id={input.id}
                            type={input.type}
                            label={props.t(`addressform:${input.label}`)}
                            className="mb-2"
                            variant="outlined"
                            value={CustomerData[input.name]}
                            autoComplete={input.autocomplete}
                            fullWidth
                            inputProps={{
                              maxLength: input.max,
                              minLength: input.min,
                              autocomplete: input.autocomplete,
                              // ...(site_id !== 124  && {readOnly: input.name === "klant_postcode" || input.name === "klant_huisnummer" ? false : true}),
                              form: {
                                autocomplete: 'off',
                              },
                            }}
                            onChange={(event) =>
                                (input.name === "klant_postcode" ||
                                    input.name === "klant_huisnummer" ||
                                    input.name === "klant_plaats" ||
                                    input.name === "klant_straat") &&
                                handleChange(event)
                            }
                            helperText={
                              errors[input.name]
                                  ? props.t(`addressform:${errors[input.name].message}`)
                                  : validation[input.name] === false
                                      ? props.t(`addressform:EmptyField`)
                                      : input.helperText &&
                                      props.t(`addressform:${input.helperText}`)
                            }
                            error={errors[input.name] || validation[input.name] === false}
                        />

                        {loadingAddressByZipcode && (
                            <LinearProgress
                                className="align-self-center"
                                style={{ color: primary_color_2 }}
                            />
                        )}
                      </Grid>
                  ) : //field: checkbox foreign (belgium)
                  (input.name === "foreign" && foreignOption === true) ||
                  input.name === "downloads" ||  input.name === "oudste_kind" ? (
                          <Grid
                              item
                              key={key}
                              lg={lg}
                              md={12}
                              sm={12}
                              xd={12}
                              className={`mb-2`}
                              style={{
                                display: `${input.name === "downloads" ? "none" : "unset" || input.name === "oudste_kind" ? "none" : "unset"}`,
                              }}
                          >
                            <input
                                {...register(input.name, { shouldUnregister: true })}
                                id={input.id}
                                name={input.name}
                                type={input.type}
                                checked={
                                  (input.name === "foreign" && foreign) ||
                                  (input.name === "downloads" && type === "Only downloads") || (input.name === "oudste_kind" && verzendkostenvrij_korting_datum===true && oudste_kind_k==='true')
                                }
                                color="primary"
                                className="mb-2"
                            />
                            <label>{props.t(`addressform:${input.label}`)}</label>

                            {errors[input.name] && (
                                <Alert severity="warning">
                                  {props.t(`addressform:${errors[input.name].message}`)}
                                </Alert>
                            )}
                          </Grid>
                      ) : //all other fields
                      input.name !== "foreign" ? (
                          <Grid
                              item
                              key={key}
                              lg={lg}
                              md={12}
                              sm={12}
                              xs={12}
                              className={`mb-2`}
                              style={{
                                display: `${
                                    classesOfSchoolFields === true ||
                                    shippingUrgentField === true ||
                                    shippingField === true
                                        ? display
                                            ? "unset"
                                            : "none"
                                        : "unset"
                                }`,
                              }}
                          >
                            {/*{input.multiline}*/}
                            {input.multiline !== true && (
                            <TextField
                                {...register(input.name, { shouldUnregister: true })}
                                id={input.id}
                                type={input.type}
                                select={
                                  input.type === "select" &&
                                  (input.name === "klant_oudste_kind_klas" ||
                                      input.name === "shipping_urgent" ||
                                      input.name === "shipping_method")
                                }
                                SelectProps={
                                  input.type === "select"
                                      ? {
                                        native: true,
                                      }
                                      : {}
                                }
                                value={
                                  input.name === "klant_oudste_kind_klas"
                                      ? CustomerData.klant_oudste_kind_klas
                                      : input.name === "shipping_urgent"
                                          ? urgent
                                          : input.name === "shipping_method"
                                              ? shippingMethod // Update the value to shippingMethod
                                              : undefined
                                }
                                label={
                                  input.name === "klant_voornaam" && site_id === "66"
                                      ? "Naam Kind: (zoals op school ingeschreven)"
                                      : props.t(`addressform:${input.label}`)
                                }
                                autoComplete={input.autocomplete}
                                multiline={input.multiline}
                                rows={input.rows}
                                max={input.max}
                                min={input.min}
                                autoFocus={key === 0}
                                onChange={(event) =>
                                    (input.name === "shipping_urgent" &&
                                        setUrgent(event.target.value)) ||
                                    (input.name === "klant_oudste_kind_klas" &&
                                        setCustomerData((prevState) => ({
                                          ...prevState,
                                          klant_oudste_kind_klas: event.target.value,
                                        }))) ||
                                    (input.name === "shipping_method" &&
                                        setShippingByHandMethod(event.target.value))
                                }
                                InputLabelProps={
                                  shippingField ||
                                  input.name === "shipping_urgent" ||
                                  input.name === "klant_oudste_kind_klas"
                                      ? { shrink: true }
                                      : null
                                }
                                helperText={
                                  errors[input.name]
                                      ? props.t(`addressform:${errors[input.name].message}`)
                                      : validation[input.name] === false
                                          ? props.t(`addressform:EmptyField`)
                                          : input.helperText &&
                                          props.t(`addressform:${input.helperText}`)
                                }
                                error={Boolean(errors[input.name]) || validation[input.name] === false}
                                className="mb-2"
                                variant="outlined"
                                fullWidth
                            >
                              {input.type === "select" && (
                                  <option value="select">
                                    {`${props.t("addressform:Select")} ${
                                        input.name === "klant_oudste_kind_klas"
                                            ? `${props.t("addressform:Class")}`
                                            : input.name === "shipping_urgent"
                                                ? `${props.t("addressform:Shipping priority")}`
                                                : input.name === "shipping_method"
                                                    ? `${props.t("addressform:Shipping method")}`
                                                    : null
                                    }`}
                                  </option>
                              )}
                              {input.type === "select" &&
                              input.name === "klant_oudste_kind_klas"
                                  //hier
                                  ? dataClassSchool &&
                                  dataClassSchool.classesofschool
                                      .slice()
                                      .sort((a, b) => {
                                        const aNum = parseInt(a.folder_name, 10);
                                        const bNum = parseInt(b.folder_name, 10);

                                        if (!isNaN(aNum) && !isNaN(bNum)) {
                                          return bNum - aNum;
                                        }

                                        if (a.folder_name < b.folder_name) {
                                          return 1;
                                        } else if (a.folder_name > b.folder_name) {
                                          return -1;
                                        } else {
                                          return 0;
                                        }
                                      })
                                      // .filter((classes) => classes.folder_name !== 'personeel' && classes.folder_name !== 'familie')
                                      .map((classes, i) => {
                                        return (
                                            <option key={i} value={classes.folder_name}>
                                              {classes.folder_name}
                                            </option>
                                        );
                                      })
                                  : input.name === "shipping_urgent" &&
                                  valueShippingUrgentField
                                      ? shippingUrgentArray.map((a, i) => {
                                        return (
                                            <option key={i} value={i}>
                                              {a}
                                            </option>
                                        );
                                      })
                                      : input.name === "shipping_method" &&
                                      valueShippingMethodField &&
                                      dataShippingMethod &&
                                      dataShippingMethod.shippingmethods.map(
                                          (shippingmet, i) => {
                                            // Check if the value is not 'verzekerd'
                                            if (shippingmet.shipping_method_name !== "verzendkosten verzekerd") {
                                              return (
                                                  <option
                                                      key={i}
                                                      value={shippingmet.shipping_method_value}
                                                  >
                                                    {shippingmet.shipping_method_name}
                                                  </option>
                                              );
                                            }
                                            return null;
                                          }
                                      )}
                            </TextField>)}
                            {input.multiline === true && comments===true && (
                                <TextField
                                    {...register(input.name, { shouldUnregister: true })}
                                    id={input.id}
                                    type={input.type}
                                    select={
                                        input.type === "select" &&
                                        (input.name === "klant_oudste_kind_klas" ||
                                            input.name === "shipping_urgent" ||
                                            input.name === "shipping_method")
                                    }
                                    SelectProps={
                                      input.type === "select"
                                          ? {
                                            native: true,
                                          }
                                          : {}
                                    }
                                    value={
                                      input.name === "klant_oudste_kind_klas"
                                          ? CustomerData.klant_oudste_kind_klas
                                          : input.name === "shipping_urgent"
                                              ? urgent
                                              : input.name === "shipping_method"
                                                  ?
                                                  dataShippingMethod.shippingmethods[0]
                                                      .shipping_method_name
                                                  : undefined
                                    }
                                    label={props.t(`addressform:${input.label}`)}
                                    autoComplete={input.autocomplete}
                                    multiline={input.multiline}
                                    rows={input.rows}
                                    max={input.max}
                                    min={input.min}
                                    autoFocus={key === 0}
                                    onChange={(event) =>
                                        (input.name === "shipping_urgent" &&
                                            setUrgent(event.target.value)) ||
                                        (input.name === "klant_oudste_kind_klas" &&
                                            setCustomerData((prevState) => ({
                                              ...prevState,
                                              klant_oudste_kind_klas: event.target.value,
                                            }))) ||
                                        (input.name === "shipping_method" &&
                                            setShippingMethod(event.target.value))
                                    }
                                    InputLabelProps={
                                      shippingField ||
                                      input.name === "shipping_urgent" ||
                                      input.name === "klant_oudste_kind_klas"
                                          ? { shrink: true }
                                          : null
                                    }
                                    helperText={
                                      errors[input.name]
                                          ? props.t(`addressform:${errors[input.name].message}`)
                                          : validation[input.name] === false
                                              ? props.t(`addressform:EmptyField`)
                                              : input.helperText &&
                                              props.t(`addressform:${input.helperText}`)
                                    }
                                    error={errors[input.name] || validation[input.name] === false}
                                    className="mb-2"
                                    variant="outlined"
                                    fullWidth
                                >
                                  {input.type === "select" && (
                                      <option value="select">
                                        {`${props.t("addressform:Select")} ${
                                            input.name === "klant_oudste_kind_klas"
                                                ? `${props.t("addressform:Class")}`
                                                : input.name === "shipping_urgent"
                                                    ? `${props.t("addressform:Shipping priority")}`
                                                    : input.name === "shipping_method"
                                                        ? `${props.t("addressform:Shipping method")}`
                                                        : null
                                        }`}
                                      </option>
                                  )}
                                  {input.type === "select" &&
                                  input.name === "klant_oudste_kind_klas"
                                      //hier
                                      ? dataClassSchool &&
                                      dataClassSchool.classesofschool.map((classes, i) => {
                                        return (
                                            <option key={i} value={classes.folder_name}>
                                              {classes.folder_name}
                                            </option>
                                        );
                                      })
                                      : input.name === "shipping_urgent" &&
                                      valueShippingUrgentField
                                          ? shippingUrgentArray.map((a, i) => {
                                            return (
                                                <option key={i} value={i}>
                                                  {a}
                                                </option>
                                            );
                                          })
                                          : input.name === "shipping_method" &&
                                          valueShippingMethodField &&
                                          dataShippingMethod &&
                                          dataShippingMethod.shippingmethods.map(
                                              (shippingmet, i) => {
                                                return (
                                                    <option
                                                        key={i}
                                                        value={shippingmet.shipping_method_value}
                                                    >
                                                      {shippingmet.shipping_method_name}
                                                    </option>
                                                );
                                              }
                                          )}
                                </TextField>)}
                            {error !== undefined && errorAddressByZipcode && (
                                <Alert severity="warning">{error}</Alert>
                            )}
                          </Grid>
                      ) : null;
            })}
          </Grid>
        </Grid>

      {/* <Grid container direction="row" className="justify-content-flex-end"> */}
      <Grid item lg={6} md={6} id="buttom-pay">
        <CartComponent {...props} shippingMethod={shippingMethod} cart={true} />
        {newsletter === "true" &&
        <Grid
            container
            direction="row"
            justifyContent="flex-start"
            alignItems="center"
        >
          <FormControlLabel control={<Checkbox defaultChecked name="newsletter" onChange={(event) =>
              handleNewsletter(event)
          }/>} label={props.t('addressform:Newsletter')} />
        </Grid>
        }
        {site_id !== "177" && (
          <Grid
            container
            direction="row"
            justifyContent="flex-start"
            alignItems="center"
          >

            <FormControlLabel
              id="acceptTerms"
              name="acceptTerms"
              checked={validation.acceptTerms}
              control={<Checkbox color="primary" name="acceptTerms" />}
              labelPlacement="end"
              label={
                <>
                  {props.t(`login:Please confirm you have read and `)}
                  <NavLink
                    style={{ color: `${primary_color_2}` }}
                    to={`/algemene_voorwaarden`}
                    target="_blank"
                  >
                    {props.t(`login:Accept our terms`)}
                  </NavLink>
                  {props.t(`login:And`)}
                  <NavLink
                    style={{ color: `${primary_color_2}` }}
                    to={`/privacy_policy`}
                    target="_blank"
                  >
                    {props.t(`login:Conditions`)}
                  </NavLink>
                </>
              }
              onChange={(e) => handleAcceptTerms(e)}
              required
            />
          </Grid>)}
        {site_id === "124" && (
          <Grid
            container
            direction="row"
            justifyContent="flex-start"
            alignItems="center"
          >

            <FormControlLabel
              id="socialMedia"
              name="socialMedia"
            value={validation.socialMedia}
            control={<Checkbox color="primary" name="socialMedia" />}
            labelPlacement="end"
            label={
              <>
                {props.t(`login:Share child socialmedia`)}
              </>
            }
            onChange={(e) => handleSocialMedia(e)}
          />
        </Grid>)}
        {site_id === "177" && (
          <Grid
            container
            direction="row"
            justifyContent="flex-start"
            alignItems="center"
          >
            <FormControlLabel control={<Checkbox name="newsletter" onChange={(event) =>
              handleNewsletter(event)
            }/>} label={props.t('login:Personalized product 1')} />
          </Grid>
        )}
        {site_id === "177" && (
          <Grid
            container
            direction="row"
            justifyContent="flex-start"
            alignItems="center"
          >
            <FormControlLabel
              id="acceptTerms"
              name="acceptTerms"
              value={validation.acceptTerms}
              control={<Checkbox color="primary" name="acceptTerms" />}
              labelPlacement="end"
              label={
                <>
                  {props.t(`login:Please confirm you have read and 1`)}
                  <a
                    style={{ color: `${primary_color_2}` }}
                    href="https://service.fotoprotools.nl/algemene_voorwaarden.pdf" // Replace with the path or URL to your PDF file
                    target="_blank"
                    rel="noopener noreferrer" // Recommended for security reasons when using target="_blank"
                  >
                    {props.t(`login:Accept our terms 1`)}
                  </a>
                  {props.t(`login:And 1`)}
                  <a
                    style={{ color: `${primary_color_2}` }}
                    href="https://service.fotoprotools.nl/privacy_policy.pdf" // Replace with the path or URL to your PDF file
                    target="_blank"
                    rel="noopener noreferrer" // Recommended for security reasons when using target="_blank"
                  >
                    {props.t(`login:Conditions 1`)}
                  </a>
                </>
              }
              onChange={(e) => handleChange(e)}
            />
          </Grid>)}
        <GeneralButton
          type="submit"
          value="submit"
          className="address-checkout-button"
          endIcon={<CreditCardIcon color="inherit" />}
        >
          {props.t("addressform:Proceed to checkout")}
        </GeneralButton>
      </Grid>
      </Grid>
    </form>
  );
}
export default React.memo(
    withTranslation(["message", "addressform"])(OrderFormComponent)
);
